import api from './index'
//
let exports = {}

// ----------------- 财务税码 --------------

// 获取财务税码列表
exports.getFiscalTaxMarkPageList = function (data, callback) {
    api.post('/fiscal/biz/tax/mark/list/get')
    .data(data)
    .done(callback)
    .go()
};

export default exports



//////////////////
// WEBPACK FOOTER
// ./src/api/fiscalBiz.js
// module id = 226
// module chunks = 1